import styled from 'styled-components';
import { color, fontSize, fontWeight, space } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';

const TitleBar = styled.div<StyledSystemProps>`
  ${color};
  ${space};
  ${fontSize};
  ${fontWeight};
`;

TitleBar.defaultProps = {
  bg: 'secondary',
  color: 'white',
  fontSize: 2,
  fontWeight: 600,
  mb: 1,
  p: 2,
};

export default TitleBar;

export const TitleBarFragment = styled.span<StyledSystemProps>`
  ${color};
  ${space};
  ${fontSize};
  ${fontWeight};
`;

TitleBarFragment.defaultProps = {
  bg: 'secondary',
  color: 'white',
  fontSize: 2,
  fontWeight: 600,
  mb: 1,
  p: 2,
};
